import { useBoolean } from "@fluentui/react-hooks";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";
import { Text } from "@fluentui/react/lib/Text";

import { Card } from "Components/Generic/Card";
import { WithConfiguration } from "Components/Generic/Configuration";
import { WithTranslator } from "Components/Generic/Translator";
import { getTranslatedFieldLabel } from "Utils/Field";
import { getItemType } from "Utils/Item";
import { isNullOrWhiteSpace, isString, sanitizeTextInput } from "Utils/String";
import { IDescriptionProps } from "./IDescriptionProps";
import { useDescriptionStyles } from "./UseDescriptionStyles";

export const Description = WithConfiguration(
  WithTranslator((props: IDescriptionProps): JSX.Element => {
    const { item, fieldName, translator } = props;

    const [isExpanded, { toggle }] = useBoolean(false);
    const { descriptionStyles, cardStyles } = useDescriptionStyles(isExpanded);

    const value = item?.[fieldName]?.toString();
    if (isNullOrWhiteSpace(value)) {
      return null;
    }

    return (
      <Card styleSet={cardStyles}>
        <>
          <Stack horizontal>
            <Stack.Item grow>
              <Text block nowrap className={descriptionStyles.header}>
                {getTranslatedFieldLabel(fieldName, getItemType(item), translator)}
              </Text>
            </Stack.Item>
            <Stack.Item disableShrink>
              <DefaultButton
                className={descriptionStyles.expand}
                iconProps={{ iconName: isExpanded ? `ChevronDown` : `ChevronRight` }}
                onClick={toggle}
              />
            </Stack.Item>
          </Stack>
          <Text block className={descriptionStyles.text} variant="medium">
            {ConvertDescriptionInput(sanitizeTextInput(value))}
          </Text>
        </>
      </Card>
    );
  })
);

function ConvertDescriptionInput(input: string): JSX.Element {
  if (input == null || !isString(input)) {
    return null;
  }

  return (
    <>
      {/* eslint-disable-next-line react/destructuring-assignment */}
      {input
        .replaceAll(`\r\n`, `\n`)
        .split(`\n`)
        .map((value, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <p key={index}>{value}</p>
        ))}
    </>
  );
}
